import React from 'react';
import { Box } from '@skin-seoul/design-system';
interface SliderDotProps {
  isSelected: boolean;
  onClick: () => void;
  size?: 'sm' | 'md' | 'lg';
}
const SliderDot = ({
  isSelected,
  onClick,
  size = 'md'
}: SliderDotProps) => {
  const sizeMap = {
    sm: {
      width: '4px',
      height: '4px',
      borderRadius: '2px'
    },
    md: {
      width: '6px',
      height: '6px',
      borderRadius: '3px'
    },
    lg: {
      width: '8px',
      height: '8px',
      borderRadius: '4px'
    }
  };
  const selectedSizeMap = {
    sm: {
      borderRadius: '8px'
    },
    md: {
      borderRadius: '12px'
    },
    lg: {
      borderRadius: '16px'
    }
  };
  const currentSize = sizeMap[size];
  const currentSelectedSize = selectedSizeMap[size];
  return <Box as="button" onClick={onClick} width={currentSize.width} height={currentSize.height} borderRadius={isSelected ? currentSelectedSize.borderRadius : currentSize.borderRadius} backgroundColor={isSelected ? 'neutral.400' : 'neutral.100'} margin={0} transition="all 0.3s" cursor="pointer" border="none" padding={0} _hover={{
    backgroundColor: isSelected ? 'neutral.500' : 'neutral.200'
  }} data-sentry-element="Box" data-sentry-component="SliderDot" data-sentry-source-file="SliderDot.tsx" />;
};
export default SliderDot;